// Кнопки «+» в секциях MyNestBox: добавляют товар так же, как родная кнопка Dawn, и открывают корзину-шторку
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-mnb-add]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;

  const drawer = document.querySelector('cart-drawer');
  const body = { items: [{ id: Number(btn.dataset.mnbAdd), quantity: 1 }] };
  if (drawer) {
    body.sections = drawer.getSectionsToRender().map((s) => s.id);
    body.sections_url = window.location.pathname;
  }

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const state = await res.json();
    if (!res.ok || state.status) throw new Error(state.description || 'Could not add to cart');
    btn.classList.add('is-added');
    btn.textContent = 'Added';
    if (drawer) drawer.renderContents(state);
    else window.location.href = window.Shopify.routes.root + 'cart';
  } catch (err) {
    btn.textContent = '!';
    btn.title = err.message;
  }

  setTimeout(() => {
    btn.classList.remove('is-added');
    btn.textContent = '+';
    btn.removeAttribute('title');
    btn.disabled = false;
  }, 1800);
});
